import React, { useState } from "react";

function ReadMoreText({ text = "", maxCharCount, style, id }) {
    const [expanded, setExpanded] = useState(false);

    const toggleText = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            {text && text.length > maxCharCount ? (
                <div
                    style={style}
                    id={id}
                    className={`long-text ${expanded ? "expanded" : ""}`}
                >
                    <div style={{ cursor: "pointer" }} onClick={toggleText}>
                        {expanded ? text : `${text.slice(0, maxCharCount)}... `}
                        {!expanded && <strong>Read more</strong>}
                    </div>
                </div>
            ) : (
                <div>{text || "No content available"}</div>
            )}
        </>
    );
}

export default ReadMoreText;
